import React, { Component, Fragment } from "react";
import Navbar from "../../Components/ProducaoEP/Realizado/UI/Navbar";
import Tabela from "../../Components/ProducaoEP/Realizado/Relatorio3/Tabela";
import TabelaMetaRealizado from "../../Components/ProducaoEP/Realizado/Relatorio3/TabelaMetaRealizado";
import NomeUnidade from "../../Components/UI/NomeUnidade";
import MenuRelatorioEP from "./menuRelatorioEP";

export default class PageRelatorio2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
    }

    render() {
        return(
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioEP />
                    <div className="row">
                        <div className="col-md-12">
                            <Tabela />
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}